export default __webpack_public_path__ + "static/media/Pattern4.1f299ca3.png";